import { Component, OnInit, Inject, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { Subscription } from "rxjs";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { CoreLanguageService } from "../../services/language.service";
import { CoreLogService } from "../../services/log.service";

interface ConfirmationModalDialogModalData {
  title: string | (() => string);
  description?: string | (() => string);
  buttonText: string | (() => string);
  showIOSAppLink?: boolean;
  icon?: boolean;
}
@Component({
  selector: "YA-confirmationModalDialog",
  templateUrl: "./confirmationModalDialog.component.html",
  styleUrls: ["./confirmationModalDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationModalDialogComponent implements OnInit, OnDestroy {
  private _localeChangeSubscription: Subscription;

  constructor(public bottomSheetRef: MatBottomSheetRef<ConfirmationModalDialogComponent>
    , private _internationalisationService: InternationalisationService
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , @Inject(MAT_BOTTOM_SHEET_DATA) public modalData: ConfirmationModalDialogModalData) { }

  ngOnInit() {
    this._localeChangeSubscription = this._internationalisationService.localeChanged.subscribe(() => {
      this.PushChanges();
    });
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("OrderResultComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  public confirm() {
    const me = this;
    me.bottomSheetRef.dismiss(true);
  }

  public evaluateLanguageString(s: string | (() => string) | boolean): string {
    const me = this;
    if (typeof s === "string") {
      return me._coreLanguageService.value(s);
    } else if (typeof s === "function") {
      return s();
    }
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._localeChangeSubscription) {
      me._localeChangeSubscription.unsubscribe();
    }
  }
}
